module.exports = __webpack_public_path__ + "static/media/new-york-we-facilitate.d87a6ba0.png";